import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useLang } from "@/context/LangContext";
import { COLLECTIONS } from "@/data/photos";

const NAV_LABELS = {
  it: { contact: "Contatti" },
  en: { contact: "Contact" },
};

function Nav() {
  const { lang } = useLang();
  const { pathname } = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const labels = NAV_LABELS[lang] || NAV_LABELS.it;
  const isHome = pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 text-paper ${
        transparent
          ? "bg-gradient-to-b from-ink/70 via-ink/30 to-transparent"
          : "bg-ink/95 backdrop-blur border-b border-paper/10"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-3 sm:py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 notranslate" translate="no" data-testid="brand-mark">
          <img
            src="/logo-white.png"
            alt="Simon O. logo"
            className="w-9 h-9 sm:w-11 sm:h-11 object-contain"
          />
          <div className="leading-none">
            <div className="font-display font-black text-xl sm:text-2xl tracking-tight">
              Simon <span className="italic font-normal">O.</span>
            </div>
            <div className="font-mono text-[0.55rem] sm:text-[0.6rem] tracking-[0.28em] uppercase opacity-70 mt-1">
              The Barber Photographer
            </div>
          </div>
        </Link>
        <nav className="flex items-center gap-4 sm:gap-5 font-mono text-[0.7rem] uppercase tracking-[0.22em]">
          {COLLECTIONS.map((c) => (
            <Link
              key={c.slug}
              to={`/collezione/${c.slug}`}
              className="hidden lg:inline hover:opacity-60 transition-opacity"
              data-testid={`nav-${c.slug}`}
            >
              {lang === "en" ? c.titleEn : c.titleIt}
            </Link>
          ))}
          <Link to="/contatti" className="hidden sm:inline hover:opacity-60 transition-opacity" data-testid="nav-contact">
            {labels.contact}
          </Link>
          <LanguageSwitcher scrolled={false} />
        </nav>
      </div>
    </header>
  );
}

export default Nav;
